import React, { useState } from 'react';
import { FormattedHTMLMessage, InjectedIntl, injectIntl } from 'react-intl';
import {
    ExtendedFieldValidationErrors,
    FieldValidationErrors,
    VerificationService,
} from '@sheerid/jslib';
import { ClassGroupComponent } from '../ClassGroup/ClassGroupComponent';
import { ClassNameComponent } from '../ClassName/ClassNameComponent';
import { ClassGroupChoice, ClassIDChoice } from '../../../lib/types/types';

interface MinorProps {
    isErrored: boolean;
    intl: InjectedIntl;
    verificationService: VerificationService;
    onChange: any;
    value: ClassIDChoice;
}

export const Minor = ({
    isErrored,
    intl,
    verificationService,
    onChange,
    value,
}: MinorProps) => {
    const fieldValidationErrors: FieldValidationErrors & ExtendedFieldValidationErrors = verificationService.fieldValidationErrors;
    const [minorGroup, setMinorGroup] = useState(undefined);

    return (
        <div className="sid-field">
            <div className="sid-l-space-top-md" />
            <label htmlFor="sid-minor">
                <div className="sid-field__label sid-field__label--required sid-l-space-btm-sm">
                    <FormattedHTMLMessage
                        id="myMinor"
                        defaultMessage="My Minor"
                    />
                </div>
                <div className="sid-field__label-explanation">
                    <FormattedHTMLMessage
                        id="optionalExplanation"
                        defaultMessage="(optional)"
                    />
                </div>
            </label>
            <div className='sid-minor-inputs'>
                <ClassGroupComponent
                    value={minorGroup}
                    onChange={(choice: ClassGroupChoice) => {
                        setMinorGroup(choice);
                        onChange(undefined);
                    }}
                    isErrored={!!fieldValidationErrors.minorClassGroup}
                    placeholder={
                        intl.formatMessage({
                            id: 'areaOfStudy',
                            defaultMessage: 'Area of Study',
                        })
                    }
                    inputId="sid-minor-class-group"
                    fieldId="minorClassGroup"
                />
                <ClassNameComponent
                    value={value}
                    onChange={(choice: ClassIDChoice) => onChange(choice) }
                    classGroup={minorGroup}
                    isErrored={!!fieldValidationErrors.minor}
                    placeholder={
                        intl.formatMessage({
                            id: 'minorPlaceholder',
                            defaultMessage: 'Minor',
                        })
                    }
                    fieldId="minorClassName"
                    inputId="sid-minor-class-id"
                />
            </div>

            {
                isErrored ? (
                    <div className="sid-field-error">
                        <FormattedHTMLMessage
                            id="errorId.invalidMinor"
                            defaultMessage="Invalid minor"
                        />
                    </div>
                ) : null
            }
        </div>
    );
};

export const MinorComponent = injectIntl(Minor);
